import { useCallback, useEffect, useState } from "react";
import apiClient from "../api/apiClient";

interface UseTeacherMetricsParams {
  schoolHash?: string;
  grade?: string;
  username?: string;
  range?: "weekly" | "monthly";
  enabled?: boolean;
}

export function useTeacherMetrics({
  schoolHash,
  grade,
  username,
  range = "monthly",
  enabled = true,
}: UseTeacherMetricsParams) {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTeacherMetrics = useCallback(async () => {
    if (!enabled || !schoolHash || !grade || !username) return;

    const url = `/metrics/teacher/${schoolHash}/${grade}/${username}`;
    const params: any = {};
    if (range === "monthly") params.range = "monthly";

    try {
      setLoading(true);
      setError(null);
      const res = await apiClient.get(url, { params });
      setData(res.data);
    } catch (err: any) {
      console.error("Teacher metrics API error:", err);
      setError(
        err?.response?.data?.message ||
          err.message ||
          "Failed to load teacher metrics",
      );
    } finally {
      setLoading(false);
    }
  }, [schoolHash, grade, username, range, enabled]);

  useEffect(() => {
    if (!enabled) return;
    fetchTeacherMetrics();
  }, [fetchTeacherMetrics, enabled]);

  return {
    data,
    loading,
    error,
    refetch: fetchTeacherMetrics,
  };
}
